/**
 * Dil (TR / EN) — dünyadaki kanvas yazıları ve menü bu sözlükten okur.
 * Diller ayrı gösterilir (aynı anda iki dil yok). Tercih localStorage'da; yoksa tarayıcı dili.
 * Yeni anahtar eklerken iki dile de yaz: `npm run check:assets` eksik çeviriyi hata sayar.
 */
const strings = {
    tr: {
        menu: 'Menü',
        close: 'Kapat',
        language: 'Dil',
        tabControls: 'Kontroller',
        tabVehicle: 'Araç',
        tabEnvironment: 'Ortam',
        drive: 'Sür',
        boost: 'Hızlan',
        brake: 'Fren',
        resetCar: 'Aracı sıfırla',
        honk: 'Korna',
        mute: 'Sesi kapat / aç',
        pickVehicle: 'Araç seç',
        colorTheme: 'Renk teması',
        useArea: 'Alanı kullan',
        zoom: 'Yakınlaş / uzaklaş',
        wheelKey: 'Teker',
        toggleMenu: 'Menüyü aç / kapat',
        touchJoystick: 'Sol alttaki kumanda',
        touchBoost: 'Hızlan',
        touchForward: 'İleri',
        touchBrake: 'Fren',
        touchBackward: 'Geri',
        garageNote: 'Garaja girip Enter’a basarak da değiştirebilirsin.',
        themeTitle: 'Renk dünyası',
        sound: 'Ses',
        soundOn: 'Açık',
        soundOff: 'Kapalı',
        startNote: 'Seçimin START’a basınca uygulanır.',
        musicToggle: 'Müzik',
        sfxToggle: 'Ses',
        soundHint: 'Ses için tıkla ya da bir tuşa bas',
        soundAll: 'Tümü',
        effectsToggle: 'Efekt',
        muteSound: 'Sesi kapat',
        unmuteSound: 'Sesi aç',
        tabContact: 'İletişim',
        soundHintTouch: 'Ses için dokun',
        garageHintKey: 'ENTER’A BAS',
        garageHintTouch: 'ALANA DOKUN',
        garageHintAction: 'ARACI DEĞİŞTİR',

        // Zemin yazıları
        floorArrows: 'YÖN TUŞLARIYLA SÜR',
        floorTouch: 'EKRANDAKİ KUMANDAYLA SÜR',
        floorHintTop: 'TÜM KONTROLLER',
        floorHintBottom: 'EKRANIN ALTINDAKİ MENÜDE · ESC',
        floorReset: 'SIFIRLA',
        floorOpen: 'AÇ',
        floorTheme: 'TEMA',
        floorGarage: 'GARAJ',
        signProjects: 'PROJELER',
        signContact: 'İLETİŞİM',
        signPlayground: 'OYUN ALANI',
        contactEmail: 'E-POSTA'
    },
    en: {
        menu: 'Menu',
        close: 'Close',
        language: 'Language',
        tabControls: 'Controls',
        tabVehicle: 'Vehicle',
        tabEnvironment: 'Environment',
        drive: 'Drive',
        boost: 'Boost',
        brake: 'Brake',
        resetCar: 'Reset the car',
        honk: 'Honk',
        mute: 'Mute / unmute',
        pickVehicle: 'Pick a vehicle',
        colorTheme: 'Color theme',
        useArea: 'Use an area',
        zoom: 'Zoom in / out',
        wheelKey: 'Wheel',
        toggleMenu: 'Open / close the menu',
        touchJoystick: 'Joystick, bottom left',
        touchBoost: 'Boost',
        touchForward: 'Forward',
        touchBrake: 'Brake',
        touchBackward: 'Reverse',
        garageNote: 'You can also switch in the garage by pressing Enter.',
        themeTitle: 'Color world',
        sound: 'Sound',
        soundOn: 'On',
        soundOff: 'Off',
        startNote: 'Your choice applies when you press START.',
        musicToggle: 'Music',
        sfxToggle: 'Sound',
        soundHint: 'Click or press any key for sound',
        soundAll: 'All',
        effectsToggle: 'Effects',
        muteSound: 'Mute',
        unmuteSound: 'Unmute',
        tabContact: 'Contact',
        soundHintTouch: 'Tap for sound',
        garageHintKey: 'PRESS ENTER',
        garageHintTouch: 'TAP THE AREA',
        garageHintAction: 'SWITCH VEHICLE',

        floorArrows: 'DRIVE WITH THE ARROW KEYS',
        floorTouch: 'USE THE ON-SCREEN CONTROLS',
        floorHintTop: 'ALL CONTROLS',
        floorHintBottom: 'IN THE MENU AT THE BOTTOM · ESC',
        floorReset: 'RESET',
        floorOpen: 'OPEN',
        floorTheme: 'THEME',
        floorGarage: 'GARAGE',
        signProjects: 'PROJECTS',
        signContact: 'CONTACT',
        signPlayground: 'PLAYGROUND',
        contactEmail: 'EMAIL'
    }
}

const listeners = new Set()

let lang = 'tr'
try
{
    const stored = window.localStorage.getItem('llpause.lang')
    lang = strings[stored] ? stored : (navigator.language || 'tr').toLowerCase().startsWith('tr') ? 'tr' : 'en'
}
catch(_error)
{
    lang = (navigator.language || 'tr').toLowerCase().startsWith('tr') ? 'tr' : 'en'
}
document.documentElement.lang = lang

export function t(_key)
{
    return strings[lang][_key] ?? strings.tr[_key] ?? _key
}

// { tr, en } nesnesinden o anki dil
export function pick(_value)
{
    return typeof _value === 'string' ? _value : _value[lang] ?? _value.tr
}

export function getLang()
{
    return lang
}

export function setLang(_lang)
{
    if(!strings[_lang] || _lang === lang)
    {
        return
    }
    lang = _lang
    document.documentElement.lang = lang
    try
    {
        window.localStorage.setItem('llpause.lang', lang)
    }
    catch(_error) {}
    for(const _listener of listeners)
    {
        _listener(lang)
    }
}

export function onLang(_listener)
{
    listeners.add(_listener)
    return () => listeners.delete(_listener)
}

export const languages = Object.keys(strings)
